module.exports = __webpack_public_path__ + "media/application/images/svgs/camera-163d4d36df749f3edcc32dad8a0f3c72.svg";